<div
  class="order-confirmation-page min-h-screen flex justify-center items-start px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10 pb-28 md:pb-10">
  <div class="w-full max-w-[644px] flex flex-col items-center gap-4 sm:gap-6 md:gap-8">
    <!-- Status icon + title -->
    <div class="w-full max-w-[470px] flex flex-col items-center gap-2"
      [@slideInFromTop]="confirmationVisible ? 'visible' : 'void'">
      <div class="w-16 h-16 sm:w-20 sm:h-20 relative flex items-center justify-center"
        *ngIf="success || returOrder || orderCancel || isEnquiry">
        <svg class="w-12 h-12 sm:w-[52px] sm:h-[52px]" viewBox="0 0 52 52" fill="none"
          xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="26" cy="26" r="26" fill="#16A34A" />
          <path d="M15 27.5L22.5 35L37 18.5" stroke="white" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <div class="w-16 h-16 sm:w-20 sm:h-20 relative flex items-center justify-center"
        *ngIf="!success && !orderCancel && !returOrder && !isEnquiry">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="red" class="w-12 h-12 sm:w-14 sm:h-14">
          <title>cancel</title>
          <g>
            <path
              d="M22.36,11.05,21,9.64a2,2,0,0,0-2.83,0L16,11.76,13.88,9.64a2,2,0,0,0-2.83,0L9.64,11.05a2,2,0,0,0,0,2.83L11.76,16,9.64,18.12a2,2,0,0,0,0,2.83l1.41,1.41a2,2,0,0,0,2.83,0L16,20.24l2.12,2.12a2,2,0,0,0,2.83,0L22.36,21a2,2,0,0,0,0-2.83L20.24,16l2.12-2.12A2,2,0,0,0,22.36,11.05Zm-4.24,4.24a1,1,0,0,0,0,1.42L21,19.54,19.54,21l-2.83-2.83a1,1,0,0,0-1.42,0L12.46,21l-1.41-1.41,2.83-2.83a1,1,0,0,0,0-1.42l-2.83-2.83,1.41-1.41,2.83,2.83a1,1,0,0,0,1.42,0l2.83-2.83L21,12.46Z" />
            <path d="M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm0,28A13,13,0,1,1,29,16,13,13,0,0,1,16,29Z" />
          </g>
        </svg>
      </div>

      <h1 *ngIf="isEnquiry && !orderCancel && !returOrder"
        class="w-full text-center text-green-600 text-2xl sm:text-3xl font-bold leading-tight">
        Enquiry Submitted
      </h1>
      <h1 *ngIf="success && !isEnquiry"
        class="w-full text-center text-green-600 text-2xl sm:text-3xl font-bold leading-tight">
        Order confirmed
      </h1>
      <h1 *ngIf="!success && !orderCancel && !returOrder && !isEnquiry"
        class="w-full text-center text-red-600 text-2xl sm:text-3xl font-bold leading-tight">
        Order canceled
      </h1>
      <h1 *ngIf="orderCancel" class="w-full text-center text-green-700 text-2xl sm:text-3xl font-bold leading-tight">
        Cancellation Successful
      </h1>
      <h1 *ngIf="returOrder" class="w-full text-center text-green-700 text-2xl sm:text-3xl font-bold leading-tight">
        Return Initiated Successfully
      </h1>
    </div>

    <!-- Status message -->
    <p *ngIf="isEnquiry && !orderCancel && !returOrder"
      class="w-full max-w-[470px] text-center text-black text-sm sm:text-base font-medium leading-normal">
      Your enquiry has been submitted successfully. Our team will get in touch with you shortly.
    </p>
    <!-- <div
      *ngIf="isEnquiry && enquiryNumber && !orderCancel && !returOrder"
      class="mt-1 px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-[#0A0A5F] text-xs sm:text-sm font-semibold"
    >
      Enquiry Number: {{ enquiryNumber }}
    </div> -->
    <p *ngIf="success && !isEnquiry"
      class="w-full max-w-[470px] text-center text-black text-sm sm:text-base font-medium leading-normal">
      We are getting started on your order right away and you will receive an
      order confirmation email/SMS soon.
    </p>
    <p *ngIf="!success && !orderCancel && !returOrder && !isEnquiry"
      class="w-full max-w-[470px] text-center text-black text-sm sm:text-base font-medium leading-normal">
      We’ve processed your cancellation request, and you’ll receive a
      confirmation email/SMS shortly.
    </p>
    <p *ngIf="orderCancel"
      class="w-full max-w-[470px] text-center text-black text-sm sm:text-base font-medium leading-normal">
      We’ve processed your cancellation request, and you’ll receive a
      confirmation email/SMS shortly.
    </p>
    <p *ngIf="returOrder"
      class="w-full max-w-[470px] text-center text-black text-sm sm:text-base font-medium leading-normal">
      We’ve processed your retrun request, and you’ll receive a confirmation
      email/SMS shortly.
    </p>

    <!-- Cancel / return notices -->
    <div class="w-full p-3 sm:p-4 rounded-lg border border-gray-200 bg-[#E2F3F5]" *ngIf="orderCancel">
      <p class="text-[#1F5C6D] text-sm sm:text-base font-bold leading-6">
        <ng-container *ngIf="totalBookingAmount">
          Your refund of ₹{{ totalBookingAmount }} has been processed to your
          original payment method. It may reflect in 2–4 business days.
        </ng-container>
        <ng-container *ngIf="!totalBookingAmount">
          Your refund has been processed to your original payment method. It may reflect in 2–4 business days.
        </ng-container>
      </p>
    </div>

    <div class="w-full p-3 sm:p-4 rounded-lg border border-gray-200 bg-gray-200" *ngIf="returOrder">
      <p class="text-[#0b296a] text-sm sm:text-base font-bold leading-6">
        <ng-container *ngIf="totalBookingAmount">
          Your refund of ₹{{ totalBookingAmount }} will be initiated to your
          original payment method once the return is successfully completed.
        </ng-container>
        <ng-container *ngIf="!totalBookingAmount">
          Your refund will be initiated to your original payment method once the return is successfully completed.
        </ng-container>
      </p>
    </div>

    <!-- Delivery / pickup address -->
    @if (!returOrder && !orderCancel) {
    <div class="w-full p-3 sm:p-4 rounded-lg border border-gray-200 flex flex-col gap-2" *ngIf="homeAddress.length > 0"
      [@slideInFromBottom]="addressVisible ? 'visible' : 'void'">
      <div class="flex flex-wrap items-center gap-2">
        <span class="text-[#0A0A5F] text-xs sm:text-sm font-bold">
          Home Delivery to :
        </span>
        <span class="text-black text-xs sm:text-sm font-bold">
          {{
          homeAddress[0]?.receiver_name
          ? homeAddress[0]?.receiver_name
          : userData?.first_name + " " + userData?.last_name
          }},
          {{ homeAddress[0]?.pincode }}
        </span>
        <span
          class="inline-flex items-center px-2.5 py-0.5 rounded-2xl border border-gray-200 text-gray-400 text-xs sm:text-sm font-bold"
          *ngIf="homeAddress[0]?.address_type">
          {{ homeAddress[0]?.address_type }}
        </span>
      </div>
      <p class="w-full text-gray-700 text-xs sm:text-sm font-medium leading-5">
        {{ homeAddress[0]?.address_1 }} {{ homeAddress[0]?.city }}
        {{ homeAddress[0]?.state }} {{ homeAddress[0]?.pincode }}
      </p>
      <div class="w-full flex flex-row justify-between items-start gap-3 flex-wrap">
        <div class="flex items-center gap-1 min-w-0">
          <span class="text-gray-400 text-xs sm:text-sm font-medium">Contact:</span>
          <span class="text-black text-xs sm:text-sm font-bold break-all">
            {{
            homeAddress[0]?.receiver_phone_no
            ? homeAddress[0]?.receiver_phone_no
            : userData?.phone_number
            }}
          </span>
        </div>
        <div class="flex items-center gap-1 min-w-0" *ngIf="homeAddress[0]?.gstin_number">
          <span class="text-gray-400 text-xs sm:text-sm font-medium">GST:</span>
          <span class="text-black text-xs sm:text-sm font-bold break-all">
            {{ homeAddress[0]?.gstin_number }}
          </span>
        </div>
      </div>
    </div>

    <div class="w-full p-3 sm:p-4 rounded-lg border border-gray-200 flex flex-col gap-2" *ngIf="storeAddress.length > 0"
      [@slideInFromBottom]="addressVisible ? 'visible' : 'void'">
      <div class="flex flex-wrap items-center gap-2">
        <span class="text-[#0A0A5F] text-xs sm:text-sm font-bold">
          Store pickup at :
        </span>
        <span class="text-black text-xs sm:text-sm font-bold">
          {{ storeAddress[0]?.address_1 }}, {{ storeAddress[0]?.pincode }}
        </span>
      </div>
      <p class="w-full text-gray-700 text-xs sm:text-sm font-medium leading-5">
        {{ storeAddress[0]?.address_1 }} {{ storeAddress[0]?.city }}
        {{ storeAddress[0]?.state }} {{ storeAddress[0]?.pincode }}
      </p>
      <div class="w-full flex flex-row justify-between items-start gap-3" *ngIf="storeAddress[0]?.phone_no">
        <div class="flex items-center gap-1 min-w-0">
          <span class="text-gray-400 text-xs sm:text-sm font-medium">Contact:</span>
          <span class="text-black text-xs sm:text-sm font-bold break-all">
            {{ storeAddress[0]?.phone_no }}
          </span>
        </div>
      </div>
    </div>
    }

    <!-- Order summary -->
    <div class="w-full flex flex-col gap-4" [@slideInFromBottom]="orderSummaryVisible ? 'visible' : 'void'">
      <h2 class="text-black text-sm sm:text-lg font-bold leading-normal">
        <ng-container *ngIf="isEnquiry && !orderCancel && !returOrder">
          Enquiry Summary - # {{ enquiryNumber || orderNumber || orderDetail?.order_detail?.order_number || "" }}
        </ng-container>
        <ng-container *ngIf="orderCancel">
          Cancellation Summary - #
          {{ orderDetail?.order_number || orderDetail?.order_invoice_list?.[0]?.order_number ||
          orderDetail?.order_deatils?.order_number || orderDetail?.order_detail?.order_number || orderNumber || orderId
          || "" }}
        </ng-container>
        <ng-container *ngIf="returOrder">
          Return Order Summary - #
          {{ orderDetail?.order_number || orderDetail?.order_invoice_list?.[0]?.order_number ||
          orderDetail?.order_deatils?.order_number || orderDetail?.order_detail?.order_number || orderNumber || orderId
          || "" }}
        </ng-container>
        <ng-container *ngIf="!orderCancel && !returOrder && !isEnquiry">
          Order Summary - # {{ orderDetail?.order_number || orderDetail?.order_deatils?.order_number ||
          orderDetail?.order_detail?.order_number || orderNumber || "" }}
        </ng-container>
      </h2>

      <div class="order-item-card w-full pb-4 border-b border-gray-200 flex gap-3 sm:gap-4 items-start" *ngFor="
          let item of (partDetails && partDetails.length > 0)
            ? partDetails
            : (orderDetail?.line_items
                ? orderDetail?.line_items
                : (orderDetail?.part_details
                    ? orderDetail?.part_details
                    : (orderDetail?.order_deatils?.order_lines
                        ? orderDetail?.order_deatils?.order_lines
                        : orderDetail?.order_invoice_list?.[0]?.invoice_items)))
        ">
        <div
          class="relative w-[88px] h-[72px] sm:w-[120px] sm:h-[96px] md:w-[144px] md:h-[112px] rounded-lg overflow-hidden bg-white shrink-0">
          <img class="w-full h-full object-cover" [src]="
              item?.part_image
                ? item?.part_image
                : item?.image_url || 'assets/default.webp'
            " [alt]="item?.part_desc || 'Product'" />
          <div *ngIf="item?.quality && item?.quality !== 'nan'"
            class="absolute top-1 left-1 sm:left-auto sm:right-1 md:left-1 md:right-auto inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md shadow font-bold text-[10px] sm:text-xs"
            [ngClass]="
              item?.quality === 'A'
                ? 'bg-green-100 text-green-800'
                : item?.quality === 'B'
                  ? 'bg-yellow-100 text-yellow-800'
                  : item?.quality === 'C'
                    ? 'bg-orange-100 text-orange-800'
                    : 'bg-green-100 text-green-800'
            ">
            <svg width="14" height="14" class="shrink-0" aria-hidden="true">
              <rect width="14" height="14" rx="3" [attr.fill]="
                  item?.quality === 'A'
                    ? '#01811D'
                    : item?.quality === 'B'
                      ? '#B8860B'
                      : item?.quality === 'C'
                        ? '#D35400'
                        : '#01811D'
                " />
              <text x="7" y="10.5" text-anchor="middle" font-size="9" font-family="Arial, sans-serif" fill="white">
                {{ item.quality }}
              </text>
            </svg>
            <span>Quality</span>
          </div>
        </div>

        <div class="flex-1 min-w-0 flex flex-col gap-1.5 sm:gap-2">
          <h3 class="text-sm sm:text-base font-bold text-black leading-snug line-clamp-2">
            {{ item?.part_desc || item?.part_name }}
          </h3>

          <div class="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-xs sm:text-sm text-gray-400 font-medium"
            *ngIf="item?.part_type === 'Used Part'">
            <span *ngIf="item?.make">{{ item?.make }}</span>
            <span class="w-1 h-1 bg-gray-400 rounded-full inline-block" *ngIf="item?.make && item?.model"></span>
            <span *ngIf="item?.model">{{ item?.model }}</span>
            <span class="w-1 h-1 bg-gray-400 rounded-full inline-block"
              *ngIf="item?.model && item?.year_of_manufacture"></span>
            <span *ngIf="item?.year_of_manufacture">{{
              item?.year_of_manufacture
              }}</span>
            <span class="w-1 h-1 bg-gray-400 rounded-full inline-block"
              *ngIf="item?.year_of_manufacture && item?.variant"></span>
            <span *ngIf="item?.variant">{{ item?.variant }}</span>
          </div>

          <div class="flex flex-wrap items-center gap-1 text-xs sm:text-sm">
            <span class="text-gray-400 font-medium">Sold by:</span>
            <span class="text-black font-bold">
              {{ getSellerName(item) }}
            </span>
          </div>

          <div class="flex items-center gap-1 text-xs sm:text-sm" *ngIf="!returOrder && !orderCancel">
            <span class="text-gray-400 font-medium">Delivery by</span>
            <span class="text-black font-bold">
              {{ item?.seller_detail?.updated_at | date: "dd MMM" }}
            </span>
          </div>

          <div class="flex items-center justify-between gap-2 text-xs sm:text-sm font-medium text-gray-700 mt-1"
            *ngIf="!returOrder && !orderCancel">
            <span *ngIf="item?.total_quantity || item?.req_quantity || item?.quantity">
              Qty: <strong class="text-black">{{ item?.total_quantity || item?.req_quantity || item?.quantity
                }}</strong>
            </span>
            <span *ngIf="item?.total_amount || item?.booking_amount || item?.part_rate" class="font-bold text-black">
              ₹{{ item?.total_amount || item?.booking_amount || item?.part_rate }}
            </span>
          </div>

          <div class="text-xs sm:text-sm font-bold text-black" *ngIf="returOrder || orderCancel">
            ₹{{ item?.booking_amount || item?.total_amount || item?.part_rate || 0 }}
          </div>
        </div>
      </div>

      <!-- Tablet + desktop CTAs -->
      <div class="hidden md:flex w-full gap-3 lg:gap-4" [@fadeIn]="buttonsVisible ? 'visible' : 'void'">
        <button type="button"
          class="flex-1 h-12 rounded-lg border border-[#0A0A5F] text-[#0A0A5F] text-base font-bold hover:bg-blue-50 transition-colors"
          (click)="gotoList()">
          Continue Shopping
        </button>
        <button type="button"
          class="flex-1 h-12 rounded-lg bg-[#0A0A5F] text-white text-base font-bold hover:bg-[#08084d] transition-colors"
          (click)="gotoProfile()">
          {{ (isEnquiry && !orderCancel && !returOrder) ? 'View Enquiry Details' : 'View Order Details' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile sticky CTAs -->
  <div
    class="cta-bar-mobile md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 sm:p-4 z-[41]">
    <div class="flex gap-2 sm:gap-3 max-w-[644px] mx-auto">
      <button type="button"
        class="flex-1 h-11 sm:h-12 rounded-lg border border-[#0A0A5F] text-[#0A0A5F] text-sm sm:text-base font-bold"
        (click)="gotoList()">
        Continue Shopping
      </button>
      <button type="button"
        class="flex-1 h-11 sm:h-12 rounded-lg bg-[#0A0A5F] text-white text-sm sm:text-base font-bold"
        (click)="gotoProfile()">
        {{ (isEnquiry && !orderCancel && !returOrder) ? 'View Enquiry Details' : 'View Order Details' }}
      </button>
    </div>
  </div>
</div>